import { IApiKey, IApiKeyCriada, IApiKeyCriar } from "../interfaces/IApiKey";
import api from "./Api";
import Swal from "sweetalert2";

const BASE_URL = process.env.REACT_APP_API_CORE_URL ?? 'https://api-core.dev.painel-agholmes.com/api/v3';

// DEVN3-627: gestão de API Keys da API pública pelo painel (Administrador e Master).
class ApiKeyService {

  // clienteId só tem efeito para Master; o Administrador sempre recebe as chaves do próprio cliente.
  async listar(clienteId?: number): Promise<IApiKey[]> {
    try {
      const { data } = await api.get<IApiKey[]>('api-key', { baseURL: BASE_URL, params: clienteId ? { clienteId } : undefined });
      return data;
    } catch (error: any) {
      Swal.fire({ text: error.message, timer: 4000, icon: 'error', showConfirmButton: false });
      return [];
    }
  }

  // A resposta traz a chave completa — não guardar fora da memória da tela.
  async criar(dados: IApiKeyCriar): Promise<IApiKeyCriada | null> {
    try {
      const { data } = await api.post<IApiKeyCriada>('api-key', dados, { baseURL: BASE_URL });
      return data;
    } catch (error: any) {
      Swal.fire({ text: error.message, timer: 6000, icon: 'error', showConfirmButton: false });
      return null;
    }
  }

  async revogar(id: number): Promise<boolean> {
    try {
      await api.post(`api-key/${id}/revogar`, null, { baseURL: BASE_URL });
      return true;
    } catch (error: any) {
      Swal.fire({ text: error.message, timer: 4000, icon: 'error', showConfirmButton: false });
      return false;
    }
  }
}

export default new ApiKeyService();
